import React from "react";
export default function Instagram(props: { color?: string; className?: string }) {
  const { color = "#818180;", className } = props;
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 33.46 33.41"
      height="33px"
      className={className}
    >
      <g fill={color}>
        <path d="M32.71,6.15A8.44,8.44,0,0,0,26.32.36a23.87,23.87,0,0,0-5-.36c-1.53-.06-3.07,0-4.61,0h-6.1a14.76,14.76,0,0,0-3.5.36A8.48,8.48,0,0,0,.78,5.86,15.26,15.26,0,0,0,0,11.3C0,15.17,0,19,.1,22.9a18.19,18.19,0,0,0,.28,3,8.6,8.6,0,0,0,2.39,4.62,9.28,9.28,0,0,0,5.86,2.62,38,38,0,0,0,3.84.18c3.41,0,6.82,0,10.23-.08a14.11,14.11,0,0,0,4.64-.72,8.32,8.32,0,0,0,4.81-4.09,12.4,12.4,0,0,0,1.21-5.32c.08-1.51.11-3,.09-4.55,0-3.05-.12-6.1-.17-9.14A10.9,10.9,0,0,0,32.71,6.15ZM30.17,25.47a5.76,5.76,0,0,1-4,4.45,14.32,14.32,0,0,1-3.68.45c-1.88,0-3.75.05-5.63.05s-3.92,0-5.87-.06a14.57,14.57,0,0,1-3.59-.43A5.65,5.65,0,0,1,3.3,25.61,11.28,11.28,0,0,1,3,23.08c-.06-3.89-.12-7.79-.08-11.69a11.73,11.73,0,0,1,.7-4.79A5.52,5.52,0,0,1,7.7,3.22a20.6,20.6,0,0,1,3.68-.38c1.77-.06,3.54,0,5.31,0s3.36,0,5,0a22.1,22.1,0,0,1,4.07.39,5.35,5.35,0,0,1,4.26,4.15,16.69,16.69,0,0,1,.39,3.54q.12,4.7.1,9.39A26.31,26.31,0,0,1,30.17,25.47Z" />
        <path d="M25.66,5.72a2,2,0,0,0-2,2,1.93,1.93,0,0,0,2,1.9,2,2,0,0,0,2-1.89A2.06,2.06,0,0,0,25.66,5.72Z" />
        <path d="M16.76,8.09a8.55,8.55,0,1,0,8.51,8.55A8.5,8.5,0,0,0,16.76,8.09Zm0,14.18a5.64,5.64,0,1,1,5.61-5.64A5.6,5.6,0,0,1,16.75,22.27Z" />
      </g>
    </svg>
  );
}
